module.exports = __webpack_public_path__ + "img/php.62a0f154.svg";